export const updateNodeData = () => defaultActions => {
    return function (nodes, transform) {
        return defaultActions.updateNodeData(
            nodes,

            (node) => {
                const {bizNodeType} = node.data

                return this.BizNode[bizNodeType].mapUpdateNodeData(
                    this,
                    node,
                    transform(node),
                )
            }
        )
    }
}
